
import React from 'react';
import { Info } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';

interface DataStatusIndicatorProps {
  useMockData: boolean;
  isSimpleLabel?: boolean;
}

const DataStatusIndicator: React.FC<DataStatusIndicatorProps> = ({ 
  useMockData,
  isSimpleLabel = false
}) => {
  if (!useMockData) return null;
  
  if (isSimpleLabel) {
    return (
      <span className="text-xs flex items-center gap-1.5 text-blue-500 bg-blue-500/10 px-2 py-1 rounded-full border border-blue-500/20">
        <Info size={14} />
        Simulated Data
      </span>
    );
  }
  
  return (
    <Alert variant="default" className="bg-blue-500/10 border-blue-500/30">
      <AlertCircle className="h-5 w-5 text-blue-500" />
      <AlertTitle className="text-blue-500 font-medium">Mock Data Displayed</AlertTitle>
      <AlertDescription>
        You're currently viewing simulated statistics. Real data will automatically appear after your first track download.
      </AlertDescription>
    </Alert>
  );
};

export default DataStatusIndicator;
